module.exports = {
  MPA_TRANSACTIONS_APPLY_REQUEST: 'MPA_TRANSACTIONS_APPLY_REQUEST',
  MPA_TRANSACTIONS_APPLY_SUCCESS: 'MPA_TRANSACTIONS_APPLY_SUCCESS',
  MPA_TRANSACTIONS_APPLY_FAILURE: 'MPA_TRANSACTIONS_APPLY_FAILURE',
};
